import { render, staticRenderFns } from "./EditarProveedorDialog.vue?vue&type=template&id=e0906432"
import script from "./EditarProveedorDialog.vue?vue&type=script&lang=js"
export * from "./EditarProveedorDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports